import React from "react";
import { Outlet } from "react-router-dom";
import Menu from "../components/Menu";
import Footer from "../components/Footer";
import '../assets/styles/main.scss';

export default function AppLayout() {
  return (
    <div>
      <header>
        <Menu />
      </header>

      <main>
        <Outlet /> {}
      </main>

      <Footer />
    </div>
  );
}
